import { mdiPlus } from '@mdi/js';
import Icon from '@mdi/react';
import { Button } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';

const CreateButton = (props) => {
  const {
    hideIcon = false,
    icon = mdiPlus,
    iconSize = 0.7,
    size = 'large',
    type = 'primary',
    text = 'Create',
    ...rest
  } = props;

  const buttonProps = {
    icon: hideIcon ? null : <Icon size={0.7} path={mdiPlus} />,
    size,
    type,
    ...rest,
  };

  return <Button {...buttonProps}>{text}</Button>;
};

CreateButton.propTypes = {
  hideIcon: PropTypes.bool,
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  size: PropTypes.oneOf(['small', 'middle', 'large']),
  type: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default CreateButton;
